// extracted by mini-css-extract-plugin
export default {"container":"InfoForTabs_container__-E3VK"};